
    import {defineComponent, reactive, toRefs, onMounted, watch, nextTick} from 'vue'
    import Swiper from 'swiper';
    import 'swiper/dist/css/swiper.css';

    interface ImgItem {
        photoPath: string;
        photoIdStr: string;
    }

    interface State {
        imgList: ImgItem[];
        bannerSwiper: object;
        slideIndex: number;
        photoName: string;
    }

    export default defineComponent({
        name: "swiperComponent",
        props: {
            imgList: {
                type: Array,
                default: () => {
                    return [];
                },
            },
            initialSlide: {
                type: Number,
                default: 0,
            }
        },
        setup(props: any, ctx: any) {
            let state: State = reactive({
                imgList: [],
                bannerSwiper: {},
                slideIndex: 0,
                photoName: '',
            })
            function urlConversion(path) {
                let reg = /^(https?:\/\/)([0-9a-z.]+)(:[0-9]+)?([/0-9a-z.]+)?(\?[0-9a-z&=]+)?(#[0-9-a-z]+)?/i
                path = path.replace(reg, "https://$2$3$4$5$6");
                return path
            }
            onMounted(() => {
                nextTick(()=>{
                    // 初始化swiper
                    const {imgList, initialSlide} = toRefs(props);
                    state.imgList = imgList.value;
                    state.photoName = (state.imgList[0] as any).photoName;
                    state.bannerSwiper = new Swiper('.swiper-container', {
                        initialSlide: initialSlide.value || 0,
                        direction: 'horizontal',
                        loop: true,
                        zoom: true,
                        virtualTranslate: false,
                        preloadImages: false,
                        observer: true,//修改swiper自己或子元素时，自动初始化swiper
                        observeParents: true,//修改swiper的父元素时，自动初始化swiper
                        on: {
                            slideChange: function () {
                                state.slideIndex = this.activeIndex
                                state.photoName = (state.imgList[this.activeIndex] as any).photoName || '';
                                // 抛出切换事件
                                let item = {
                                    index: this.activeIndex,
                                    item: state.imgList[this.activeIndex - 1]
                                }
                                ctx.emit('slideChange', item)
                            },
                        }
                    })
                    watch(initialSlide, (data: any) => {
                        (state.bannerSwiper as any).slideTo(data,300)
                    })
                })
            })
            return {
                state,
                urlConversion
            }
        }
    })
